// 改登录窗口是否打开标识
export const USER_PROFILE = "USER_PROFILE";
export const OPTIONS_EDIT = "OPTIONS_EDIT";
export const ARTICLE_TITLE_EDIT = "ARTICLE_TITLE_EDIT";
export const CURRENT_REGION = "CURRENT_REGION";
export const ACCESS_TOKEN = "ACCESS_TOKEN";



// WEBPACK FOOTER //
// ./src/store/mutationsType.js